import AuthService        from './services/auth.service';
import httpConfiguratorService from './services/http.service';

const CommonModule = angular.module('common', [])
  .service('$auth' , AuthService)
  .service('$httpConfigurator', httpConfiguratorService);

export default CommonModule;



/** WEBPACK FOOTER **
 ** ./frontend/common/common.js
 **/